/**
 * Centralized contact settings for AUTEXIO.
 *
 * The client will fill in the real production values here in ONE place;
 * every contact surface (footer, Contatti page, mailto links, wa.me links)
 * reads from these constants so a single edit propagates everywhere.
 *
 * TODO(client): replace placeholders with real values before public launch.
 */

// Real production WhatsApp number in international format
// (digits only, no `+`, no spaces — used for https://wa.me/<number>).
export const CONTACT_WHATSAPP_NUMBER = "+49 171 5778053";

// Real production support/business email address.
export const CONTACT_EMAIL = "info@autexio.de";

// Human-readable postal address (kept in DE per legal Impressum requirements).
export const CONTACT_ADDRESS = {
  company: "GT Solutions UG (haftungsbeschränkt)",
  street: "Dr. Löffellad-Straße 8",
  city: "86609 Donauwörth",
  country: "Deutschland",
};

// Helpers.
export function whatsappHref(number = CONTACT_WHATSAPP_NUMBER) {
  const digits = String(number).replace(/[^\d]/g, "");
  return digits ? `https://wa.me/${digits}` : "#";
}

export function mailtoHref(email = CONTACT_EMAIL, subject = "") {
  const q = subject ? `?subject=${encodeURIComponent(subject)}` : "";
  return `mailto:${email}${q}`;
}
